var removeFromWishList = function removeFromWishList(eventData) {
  return {
    content_id: "remover-wishlist:".concat((eventData == null ? void 0 : eventData.pageName) || null),
    content_type: (eventData == null ? void 0 : eventData.pageName) || null,
    event: 'select_content',
    item_id: (eventData == null ? void 0 : eventData.variationId) || null
  };
};
export default removeFromWishList;